"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualPremium = AnnualPremium;
exports.Payment = Payment;
exports.PaymentFrequency = PaymentFrequency;
var _react = _interopRequireDefault(require("react"));
var _DropdownForNatLangForm = require("../Wizard/DropdownForNatLangForm");
var _TextInputForNatLangForm = require("../Wizard/TextInputForNatLangForm");
var _ModalChargeWizardCalc = require("./ModalChargeWizardCalc.config");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Text inputs start here
function AnnualPremium(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'annualPremium';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '13';
  var placeholder = '000,000';
  var htmlSize = '13';
  var preText = 'My annual premium is ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      currencyWithDecimal: true,
      allowDecimals: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_ModalChargeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    prepend: true,
    id: _ModalChargeWizardCalc.idPrefix + fieldName,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function Payment(_ref2) {
  var {
    errors,
    touched,
    values
  } = _ref2;
  var fieldName = 'payment';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '13';
  var placeholder = '000,000';
  var htmlSize = '13';
  var preText = ' payments of ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      currencyWithDecimal: true,
      allowDecimals: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_ModalChargeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    prepend: true,
    id: _ModalChargeWizardCalc.idPrefix + fieldName,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    className: "endOfSentence"
  });
}
// Dropdown inputs start here
function PaymentFrequency(_ref3) {
  var {
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'paymentFrequency';
  var preText = ' and I make ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _ModalChargeWizardCalc.dropdownOptions.paymentFrequency,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    calcName: _ModalChargeWizardCalc.calcName
  });
}